/* eslint-disable */
import React, {
	ChangeEvent,
	ClipboardEvent,
	MouseEvent,
	Suspense,
	useCallback,
	useContext,
	useEffect,
	useState
} from "react";
import { Grid, Paper } from "@mui/material";
import DateFnsUtils from "@date-io/date-fns";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import EventIcon from "@mui/icons-material/Event";
import { useHistory } from "react-router-dom";

import { CustomInput } from "../../shared/CustomInput";
import { AuthContext, ThemeContext } from "../../../contexts";
import {
	HealthTestQuestionnaireFields,
	HealthTestQuestions
} from "../../../types/components/healthTestQuestionaires.types";
import {
	healthTestQuestionaires,
	healthTestQuestionnaireFieldsInitalState
} from "../../../constants/questionaire/questionairesHealthTest";
import { LazyPreviewHeatlhTestResult } from "./PreviewHeatlhTestResult/PreviewHeatlhTestResult";
import { api } from "../../../utils/api";

import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import SendIcon from "@mui/icons-material/Send";

import "./personalHealthTest.css";
import { PersonalHealthScoreResponse } from "../../../types/personalHealthScore";
import QuestionaireStyle from "./questionaireStyle/QuestionaireStyle";
import { dateConverterToUSFormat, dateTimeZoneConverter } from "../../../utils/commonFunctions/date";

import {
	heightMeasure,
	sleep,
	social,
	doctor,
	meditation,
	pollution,
	drinknWater,
	noCigratte,
	jhunkFood,
	majoreWeight,
	beerDrink,
	fattyChorestol,
	screen,
	stressLevel,
	birth,
	bloodPressure,
	dibatiesChecker,
	thryoid,
	chipsProccedFoods,
	sweets,
	eatingTime,
	exercise,
	qa,
	walkCool,
	HealthShow,
	gift
} from "../../../assets";

import Confetti from "react-confetti";
import { GiCheckeredFlag } from "react-icons/gi";
import { GiFinishLine } from "react-icons/gi";

interface State {
	rendering: boolean;
}

interface HealthScorePopupProps {
	score: string;
}

const HealthScorePopup: React.FC<HealthScorePopupProps> = ({ score }) => {
	return (
		<div className="card">
			<div className="bg">
				<div style={{ textAlign: "center" }}>
					<h3>Your Health Score</h3>
					<div>
						<img src={HealthShow} alt="Pollution Animation" />
					</div>
					<p style={{ fontWeight: 900, fontSize: "22px" }}>{score}%</p>
				</div>
			</div>
			<div className="blob"></div>
		</div>
	);
};

const PersonalHealthTest: React.FC = (): JSX.Element => {
	const [questionNumber, setQestionNumber] = useState<number>(0);
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [healthTestQuestions, setHealthTestQuestions] = useState<Array<HealthTestQuestions>>(healthTestQuestionaires);
	const [submitStatus, setSubmitStatus] = useState<boolean>(false);
	const [healthTestQuestionnaireFields, setHealthTestQuestionnaireFields] = useState<HealthTestQuestionnaireFields>(
		healthTestQuestionnaireFieldsInitalState
	);
	const [modalStatus, setModalStatus] = useState<boolean>(false);
	const [isPopupOpen, setIsPopupOpen] = useState(false);

	const [confettiVisible, setConfettiVisible] = useState(false);
	const [skippedQuestions, setSkippedQuestions] = useState<number[]>([]);
	const [showHealthScorePopup, setShowHealthScorePopup] = useState(false);
	const [healthScore, setHealthScore] = useState(null);

	const totalQuestions = 22;

	const { theme } = useContext(ThemeContext);
	const { member } = useContext(AuthContext);
	const [width, setWidth] = useState(window.innerWidth);
	const [height, setHeight] = useState(window.innerHeight);
	const [open, setOpen] = React.useState(false);

	const navigate = useHistory();

	// pop
	const showHealthScore = (score: any) => {
		setHealthScore(score);
		setShowHealthScorePopup(true);
	};

	// Handle Change and Handle Clicks
	const handleDateChangeClick = useCallback(
		(date: MaterialUiPickersDate) => {
			if (date) {
				const dateObject = new Date(date);
				const parsedDate =
					dateObject.getFullYear() + "-" + (dateObject.getMonth() + 1) + "-" + dateObject.getDate();
				setHealthTestQuestionnaireFields(
					Object.assign({}, healthTestQuestionnaireFields, {
						date_of_birth: dateTimeZoneConverter(parsedDate)
					})
				);
				setOpen(false);
			}
		},
		[healthTestQuestionnaireFields]
	);
	const selectFieldInputChange = useCallback(
		(event: ChangeEvent<HTMLInputElement>) => {
			const { value, name } = event.target;
			setHealthTestQuestionnaireFields(Object.assign({}, healthTestQuestionnaireFields, { [name]: value }));
			setOpen(false);
		},
		[healthTestQuestionnaireFields]
	);
	const handleOptionFieldInputClick = useCallback(
		(event: MouseEvent<HTMLButtonElement>, option: string) => {
			const { name } = event.currentTarget;
			setHealthTestQuestionnaireFields(Object.assign({}, healthTestQuestionnaireFields, { [name]: option }));
			setOpen(false);
		},
		[healthTestQuestionnaireFields]
	);
	const handlePaste = useCallback((event: ClipboardEvent<HTMLDivElement>) => {
		const data = event.clipboardData;
		// console.log("data from the paste function :", data);
	}, []);
	const handleSwitchQuestions = useCallback(
		(direction: "PREVIOUS" | "NEXT") => {
			if (direction === "NEXT") {
				// Check if the current question is answered
				const currentQuestionField = healthTestQuestions[questionNumber].fieldname;
				const currentQuestionValue =
					healthTestQuestionnaireFields[currentQuestionField as keyof typeof healthTestQuestionnaireFields];
				if (currentQuestionValue === undefined || currentQuestionValue === "") {
					// If not answered and not already in skippedQuestions, add the question number to the skippedQuestions array
					if (!skippedQuestions.includes(questionNumber + 1)) {
						setSkippedQuestions((prev) => [...prev, questionNumber + 1]);
					}
				}
			}
			// Move to the next or previous question based on direction
			direction === "PREVIOUS"
				? setQestionNumber((prev: number) => prev - 1)
				: direction === "NEXT"
				? setQestionNumber((prev: number) => prev + 1)
				: null;
		},
		[healthTestQuestionnaireFields, questionNumber, skippedQuestions]
	);

	const handleSkipQuestionClick = (questionNumber: number) => {
		// Navigate to the clicked skipped question
		setQestionNumber(questionNumber - 1);
		// removeSkippedQuestion(questionNumber);
	};

	const removeSkippedQuestion = (questionNumber: number) => {
		setSkippedQuestions(skippedQuestions.filter((qn) => qn !== questionNumber));
	};

	// Function to check if the current question is answered
	const checkCurrentQuestionAnswered = () => {
		const currentQuestionField = healthTestQuestions[questionNumber].fieldname;
		const currentQuestionValue =
			healthTestQuestionnaireFields[currentQuestionField as keyof typeof healthTestQuestionnaireFields];
		return currentQuestionValue !== undefined && currentQuestionValue !== "";
	};

	const handleResetButtonClick = useCallback(() => {
		const currentHealthTestQuestionaires = { ...healthTestQuestionnaireFields };
		for (const property in currentHealthTestQuestionaires) {
			if (currentHealthTestQuestionaires.hasOwnProperty(property)) {
				currentHealthTestQuestionaires[property as keyof typeof healthTestQuestionnaireFields] = "";
			}
		}
		// clearing out the whole form and sending the user to first page
		setHealthTestQuestionnaireFields(currentHealthTestQuestionaires);
		setQestionNumber(0);
		setSkippedQuestions([]);
	}, [healthTestQuestionnaireFields]);

	const handleOperateModal = useCallback((op: "OPEN" | "CLOSE") => {
		op === "OPEN" ? setModalStatus(true) : op === "CLOSE" ? setModalStatus(false) : null;
	}, []);

	// Handle Submit Functionality
	const handleSubmitPersonalHealthTest = useCallback(async () => {
		// Check if already submitting
		if (isSubmitting) return;

		setIsSubmitting(true); // Set submitting state to true

		const formCompletion = Object.values(healthTestQuestionnaireFields).filter(
			(data: string) => data.length === 0
		).length;

		if (formCompletion > 0) {
			alert("Please complete the questionnaire!");
			setIsSubmitting(false); // Reset submitting state
			return;
		}

		const { SSN, group_number } = member;

		const questionaireDataPayload: HealthTestQuestionnaireFields = healthTestQuestionnaireFields;
		const questionaireQueryPayload = {
			SSN,
			group_number
		};

		try {
			const newPersonalHealthTestInstance = await api.personalHealthScore.addPersonalHealthScore(
				questionaireDataPayload,
				questionaireQueryPayload
			);

			if (newPersonalHealthTestInstance) {
				// console.log("newPersonalHealthTestInstance", newPersonalHealthTestInstance);
				setConfettiVisible(true);
				// alert(newPersonalHealthTestInstance.health_score);
				showHealthScore(newPersonalHealthTestInstance.health_score);

				setTimeout(() => {
					navigate.push("/", {
						rendering: true,
						newPersonalHealthTestInstance: newPersonalHealthTestInstance
					});
				}, 5000); // Delay of 5 seconds
			}
		} catch (error) {
			console.error("Error occurred while submitting:", error);
		} finally {
			// Reset submitting state after 5 seconds
			setTimeout(() => {
				setIsSubmitting(false);
			}, 5000);
		}
	}, [healthTestQuestionnaireFields, member, navigate, isSubmitting]);

	const setAllData = useCallback(() => {
		const healthData = {
			alcohol_consumption: "YES",
			blood_pressure: "YES",
			cholesterol: "NO",
			daily_junk_food_consumption: "2-3 TIMES",
			daily_water_drinking: "MORE THAN 4",
			date_of_birth: "2024-3-20",
			diabetes: "YES",
			environmental_toxins: "NO",
			height: "177",
			irregular_eating_time: "4-6 DAYS",
			meditation_practice: "NO",
			processed_food_consumption: "4-6 DAYS",
			regular_exercise: "YES",
			regular_health_checkup: "YES",
			screen_on_time: "MORE THAN 5 HOURS",
			sleep_time: "5-7 HOURS",
			social_connections: "YES",
			stress_level: "MEDIUM",
			sugar_consumption: "4-6 DAYS",
			thyroid: "YES",
			tobacco_consumption: "YES",
			weight: "85"
		};

		setHealthTestQuestionnaireFields(healthData);
		setSubmitStatus(true);
		setQestionNumber(21);
	}, []);

	useEffect(() => {
		// const questionValue = healthTestQuestionnaireFields[healthTestQuestions[questionNumber].fieldname];
		const questionValue = (healthTestQuestionnaireFields as any)[healthTestQuestions[questionNumber].fieldname];

		if (questionValue !== undefined && questionValue !== "" && questionValue !== "N/A") {
			// alert(`Question ${questionNumber + 1} has been answered! Value: ${questionValue}`);
			// Remove the skipped question from the list
			removeSkippedQuestion(questionNumber + 1);
		}
	}, [healthTestQuestionnaireFields, healthTestQuestions, questionNumber]);

	// useEffect
	useEffect(() => {
		questionNumber === healthTestQuestions.length - 1 ? setSubmitStatus(true) : setSubmitStatus(false);
	}, [healthTestQuestions.length, questionNumber]);

	useEffect(() => {
		const handleResize = () => {
			setWidth(window.innerWidth);
			setHeight(window.innerHeight);
		};

		window.addEventListener("resize", handleResize);

		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, []);

	// useEffect(() => {
	// 	if (isPopupOpen) {
	// 		const timeoutId = setTimeout(() => {
	// 			setIsPopupOpen(false);
	// 		}, 3000);

	// 		return () => clearTimeout(timeoutId); // Clear the timeout when the component unmounts or when isPopupOpen changes
	// 	}
	// }, [isPopupOpen]);

	return (
		<>
			<div className="personal-health-test-main-container">
				<Suspense fallback={<div />}>
					<LazyPreviewHeatlhTestResult
						modalStatus={modalStatus}
						handleModalOperation={handleOperateModal}
						healthTestQuestionnaireFields={healthTestQuestionnaireFields}
						setQestionNumber={setQestionNumber}
					/>
				</Suspense>

				{confettiVisible && <Confetti width={width} height={height} />}

				<h3 style={{ color: theme.primary_color, fontSize: 25, textAlign: "center" }}>Personal Health Test</h3>

				<div
					style={{
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
						marginLeft: "240px",
						position: "relative"
					}}
				></div>

				<div className="questionaire-paper-container">
					<Paper className="paper-form-each-container theme-border-radius" elevation={3} variant="elevation">
						<Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
							<div className="question-container">
								{healthTestQuestions.map(
									({ question, question_type, options, fieldname, placeholder }, index) => {
										return questionNumber === index ? (
											<div
												style={{
													width: "80%",
													display: "flex",
													flexDirection: "column"
												}}
												key={index}
											>
												<div
													style={{
														display: "flex",
														alignItems: "center",
														marginBottom: "10px"
													}}
												>
													<span
														style={{
															marginRight: "10px",
															marginBottom: "20px",
															color: "black",
															fontWeight: "800",
															fontSize: "19px"
														}}
													>{`Q${index + 1}:`}</span>{" "}
													<QuestionaireStyle question={question} />
												</div>
												<Suspense fallback={<div style={{ display: "flex", flex: 2 }} />}>
													{question_type === "MULTIPLE_CHOICE_QUESTION" ? (
														<div className="multiple-choice-questions-container">
															{options?.map((option: string, index: number) => (
																<button
																	onClick={(event: MouseEvent<HTMLButtonElement>) =>
																		handleOptionFieldInputClick(event, option)
																	}
																	name={fieldname}
																	key={index}
																>
																	{option}
																</button>
															))}
														</div>
													) : question_type === "DATE" ? (
														<div className="date-picker-container">
															<MuiPickersUtilsProvider utils={DateFnsUtils}>
																<KeyboardDatePicker
																	className="date-picker-component"
																	id="from-date-input"
																	inputVariant="standard"
																	placeholder={placeholder}
																	name={fieldname}
																	format="MM/dd/yyyy"
																	error={false}
																	value={
																		fieldname === "date_of_birth"
																			? healthTestQuestionnaireFields[
																					fieldname
																			  ] != ""
																				? healthTestQuestionnaireFields[
																						fieldname
																				  ]
																				: null
																			: null
																	}
																	onChange={(date: MaterialUiPickersDate) =>
																		handleDateChangeClick(date)
																	}
																	InputProps={{
																		readOnly: true,
																		disableUnderline: true
																	}}
																	InputLabelProps={{
																		shrink: true
																	}}
																	style={{
																		width: "100%",
																		borderRadius: 10
																	}}
																	keyboardIcon={
																		<EventIcon style={{ color: "#7cb342" }} />
																	}
																	KeyboardButtonProps={{
																		"aria-label": "change date"
																	}}
																	helperText={""}
																/>
															</MuiPickersUtilsProvider>
														</div>
													) : question_type === "TEXT_INPUT" ? (
														<CustomInput
															name={fieldname}
															value={
																fieldname
																	? healthTestQuestionnaireFields[
																			fieldname as keyof typeof healthTestQuestionnaireFields
																	  ]
																	: ""
															}
															onChange={selectFieldInputChange}
															onPaste={(event: ClipboardEvent<HTMLDivElement>) =>
																handlePaste(event)
															}
															placeholder={placeholder}
														/>
													) : question_type === "BOOLEAN" ? (
														<div className="multiple-choice-questions-container">
															{options?.map((option: string, index: number) => (
																<button
																	onClick={(event: MouseEvent<HTMLButtonElement>) =>
																		handleOptionFieldInputClick(event, option)
																	}
																	name={fieldname}
																	key={index}
																>
																	{option}
																</button>
															))}
														</div>
													) : null}
													<div style={{ display: "flex", justifyContent: "center" }}>
														{questionNumber === 5 && (
															<img src={exercise} alt="Exercise Animation" />
														)}
														{questionNumber === 6 && (
															<img src={doctor} alt="Doctor Animation" />
														)}
														{questionNumber === 0 && (
															<img src={birth} alt="Birth Animation" />
														)}
														{questionNumber === 1 && (
															<img
																src={majoreWeight}
																alt="Weight Animation"
																style={{ paddingTop: "15px" }}
															/>
														)}

														{questionNumber === 2 && (
															<img
																src={heightMeasure}
																alt="Height Animation"
																style={{ paddingTop: "15px" }}
															/>
														)}
														{questionNumber === 3 && (
															<img src={drinknWater} alt="Water Animation" />
														)}
														{questionNumber === 4 && (
															<img src={sleep} alt="Sleep Animation" />
														)}
														{questionNumber === 7 && (
															<img src={meditation} alt="Meditation Animation" />
														)}
														{questionNumber === 8 && (
															<img src={social} alt="Social Animation" />
														)}
														{questionNumber === 9 && (
															<img src={pollution} alt="Pollution Animation" />
														)}
														{questionNumber === 10 && (
															<img src={beerDrink} alt="Beer Animation" />
														)}
														{questionNumber === 11 && (
															<img src={noCigratte} alt="No Cigarette Animation" />
														)}
														{questionNumber === 12 && (
															<img src={jhunkFood} alt="Junk Food Animation" />
														)}
														{questionNumber === 13 && (
															<img src={bloodPressure} alt="Blood Pressure Animation" />
														)}
														{questionNumber === 14 && (
															<img
																src={dibatiesChecker}
																alt="Diabetes Animation"
																height="125px"
																width="100px"
															/>
														)}
														{questionNumber === 15 && (
															<img src={fattyChorestol} alt="Cholesterol Animation" />
														)}
														{questionNumber === 16 && (
															<img
																src={thryoid}
																alt="Thyroid Animation"
																height="135px"
																width="160px"
															/>
														)}
														{questionNumber === 17 && (
															<img src={chipsProccedFoods} alt="Chips Animation" />
														)}
														{questionNumber === 18 && (
															<img src={screen} alt="Screen Animation" />
														)}
														{questionNumber === 19 && (
															<img src={stressLevel} alt="Stress Animation" />
														)}
														{questionNumber === 20 && (
															<img src={sweets} alt="Sweets Animation" />
														)}
														{questionNumber === 21 && (
															<img src={eatingTime} alt="Eating Time Animation" />
														)}
													</div>
												</Suspense>
												<h3
													style={{
														display: "flex",
														flex: 1,
														border: "1px solid #ccc",
														padding: "10px",
														width: "fit-content",
														borderRadius: "15px"
													}}
												>
													Selected:
													<div style={{ color: "red", marginLeft: "5px" }}>
														{fieldname
															? healthTestQuestionnaireFields[
																	fieldname as keyof typeof healthTestQuestionnaireFields
															  ]
															: "Not Selected Any Answer"}
													</div>
												</h3>
											</div>
										) : null;
									}
								)}
							</div>
						</Grid>
						<Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
							<div className="button-group-container">
								<button
									onClick={handleResetButtonClick}
									className="reset-btn"
									style={{ backgroundColor: questionNumber === 0 ? "gray" : "#ef4444" }}
								>
									<span>Reset</span>
									<RestartAltIcon fontSize="small" />
								</button>
								<div
									className={
										questionNumber < 21
											? "page-switcher-container page-switcher-container-margin-fix"
											: "page-switcher-container"
									}
									style={{ margin: "auto" }}
								>
									{questionNumber !== 0 && (
										// <button
										// 	disabled={questionNumber === 0}
										// 	onClick={() => handleSwitchQuestions("PREVIOUS")}
										// 	style={{ color: "black", background: "#7dd3fc" }}
										// >
										// 	<ArrowLeftIcon />
										// </button>
										<button
											type="button"
											className="btn btn-danger btn-lg btn3d"
											disabled={questionNumber === 0}
											onClick={() => handleSwitchQuestions("PREVIOUS")}
										>
											<span className="glyphicon glyphicon-off" />
											<ArrowLeftIcon />
										</button>
									)}
									<div className="page-indicator">
										<span>Question {questionNumber + 1}</span>
									</div>
									{questionNumber !== 21 && (
										<button
											disabled={questionNumber === healthTestQuestions.length - 1}
											onClick={() => handleSwitchQuestions("NEXT")}
											className="btn btn-danger btn-lg btn3d"
										>
											<ArrowRightIcon />
										</button>
									)}
								</div>
								{questionNumber === 21 && (
									<button
										onClick={() => {
											handleSubmitPersonalHealthTest();
											// setIsPopupOpen(true);
										}}
										disabled={questionNumber < healthTestQuestions.length - 1}
										style={
											isSubmitting || !submitStatus // If submitting or not allowed to submit yet
												? {
														backgroundColor: "gray",
														color: "white",
														cursor: "not-allowed"
												  } // Disabled style
												: submitStatus // If allowed to submit
												? {}
												: { color: "gray", cursor: "not-allowed" } // Default disabled style
										}
										className={submitStatus ? "submit-btn" : "unsubmit-btn"}
									>
										<span className="submit">Submit</span>
										<SendIcon fontSize="small" />
									</button>
								)}
							</div>
						</Grid>

						<div style={{ textAlign: "center", width: "100%" }}>
							{questionNumber === 21 && (
								<button
									onClick={() => handleOperateModal("OPEN")}
									style={{ backgroundColor: "#ef4444", color: "white" }}
									className="preview-button"
								>
									Preview
								</button>
							)}
						</div>
						<div className="progress-container" style={{ marginTop: "20px" }}>
							{/* Moving image */}
							<img
								src={questionNumber === 21 ? gift : walkCool}
								alt="Moving Image"
								className="moving-image"
								style={{
									position: "relative",
									top: "-20px",
									left: `${((questionNumber + 1) / totalQuestions) * 100}%`,
									transform: "translateX(-50%)",
									zIndex: "1"
								}}
							/>

							{/* Path line */}
							{questionNumber !== 21 && (
								// <div className="loader-line" style={{ marginTop: "10px" }}>
								<div className="loader" style={{ marginTop: "10px" }}>
									<div className="loader__element"></div>
									{/* Flag markers */}
									<div className="flag-markers-container">
										{[...Array(totalQuestions)].map((_, index) => {
											// Determine if the flag marker should be displayed
											const displayFlagMarker = questionNumber > index;

											// If the flag marker should be displayed, return the JSX for it
											return displayFlagMarker ? null : (
												<div
													key={index}
													className="flag-marker"
													style={{
														left: `${(index + 1) * (100 / totalQuestions)}%`
													}}
												>
													<div className="">
														<GiCheckeredFlag />
													</div>
												</div>
											);
										})}
									</div>
								</div>
							)}
						</div>
					</Paper>
				</div>

				{/* <button
					onClick={() => setAllData()}
					style={{ backgroundColor: theme.primary_color, color: "white" }}
					className="preview-button"
				>
					Test done
				</button> */}

				{showHealthScorePopup && (
					<HealthScorePopup
						score={healthScore ?? ""} // Provide a default value if healthScore is null
						// onClose={() => setShowHealthScorePopup(false)}
					/>
				)}

				{/* {isPopupOpen && (
					<div className="popup">
						<div className="popup-content">
							<div className="phone" style={{ textAlign: "center" }}>
								<h4 style={{ fontWeight: 800 }}>Calculating Your Health Score</h4>
								<div className="content" style={{ display: "flex", justifyContent: "center" }}>
									<div className="typewriter">
										<div className="slide">
											<i />
										</div>
										<div className="paper" />
										<div className="keyboard" />
									</div>
								</div>
								<div className="loading" style={{ marginTop: "15px" }}>
									<svg height="48px" width="64px">
										<polyline
											id="back"
											points="0.157 23.954, 14 23.954, 21.843 48, 43 0, 50 24, 64 24"
										></polyline>
										<polyline
											id="front"
											points="0.157 23.954, 14 23.954, 21.843 48, 43 0, 50 24, 64 24"
										></polyline>
									</svg>
								</div>
							</div>
						</div>
					</div>
				)} */}

				{skippedQuestions.length > 0 && (
					<div className="main-contianer-skipped">
						<div>
							<img src={qa} alt="Social Animation" />
						</div>

						<div className="skipped-questions-container">
							<h4>Questions Missed:</h4>
							<div className="skipped-questions-list">
								{skippedQuestions.length > 0 && (
									<div className="question-grid">
										{skippedQuestions.map((questionNumber, index) => (
											<div
												key={index}
												className="question-circle"
												onClick={() => handleSkipQuestionClick(questionNumber)}
											>
												{questionNumber}
											</div>
										))}
									</div>
								)}
							</div>
						</div>
					</div>
				)}
			</div>
		</>
	);
};

export default PersonalHealthTest;
